/* @flow */
import React from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { Translate, I18n } from 'react-redux-i18n'
import Grid from '@material-ui/core/Grid'
import Chip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
// import ReactCreditCard from 'react-credit-cards'
import Payment from 'payment'
import Select from 'react-select'
import moment from 'moment'
import _ from 'lodash'

import 'react-credit-cards/es/styles-compiled.css'
import './style.css'
import Header from '../../components/Header'
import Button from '../../components/Button'
import Checkbox from '../../components/Checkbox'
import Card from '../../components/Card'
import { setCurrentOrder, placeOrder } from '../../actions/order'
import { showAlert } from '../../actions/global'
import IDCheck from '../../libs/pidCheck'

type OrderProps={}
class Order extends React.Component<OrderProps> {
  initialized = false
  idTypes

  constructor(props) {
    super(props)
    this.idTypes = [
      { label: I18n.t('id'), value: 'id' },
      { label: I18n.t('passport'), value: 'passport' },
    ]
    this.state = {
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      focused: '',
      travelers: [],
      contact: {},
    }
    this.onPersonsChange = this.onPersonsChange.bind(this)
  }

  onPersonsChange(event) {
    this.setState({ persons: event.target.value })
  }

  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    })
  }

  handleInputChange = ({ target }) => {
    if (target.name === 'number') {
      this.setState({
        [target.name]: target.value.replace(/ /g, ''),
      })
    }
    else if (target.name === 'expiry') {
      this.setState({
        [target.name]: target.value.replace(/ |\//g, ''),
      })
    }
    else {
      this.setState({
        [target.name]: target.value,
      })
    }
  }

  onSubmit(event) {
    event.preventDefault()
  }

  updateTraveler(idx, info) {
    const list = Array.from(this.state.travelers)
    let idType = list[idx] && list[idx].idType
    list[idx] = { ...list[idx], ...info, idType: idType || this.idTypes[0] }
    this.setState({ travelers: list })
  }

  onNameChange(event, idx) {
    this.updateTraveler(idx, { name: event.target.value })
  }

  onIDChange(event, idx) {
    const id = event.target.value
    if ( this.state.idType === this.idTypes[0]) {
      this.updateTraveler(idx, { id, isIdValid: IDCheck(id) })
    } else {
      this.updateTraveler(idx, { id, isIdValid: id.length < 20 })
    }
  }

  // onLastNameChange(event, idx) {
  //   this.updateTraveler(idx, { lastName: event.target.value })
  // }
  // onFirstNameChange(event, idx) {
  //   this.updateTraveler(idx, { firstName: event.target.value })
  // }
  onNameChange(event) {
    this.setState({ contact: { ...this.state.contact, name: event.target.value }})
  }
  onPhoneChange(event) {
    // this.updateTraveler(idx, { phone: event.target.value })
    this.setState({ contact: { ...this.state.contact, phone: event.target.value }})
  }
  onEmailChange(event) {
    // this.updateTraveler(idx, { email: event.target.value })
    this.setState({ contact: { ...this.state.contact, email: event.target.value }})
  }

  componentDidMount() {
    if (!this.props.order) {
      const order = sessionStorage.getItem('currentOrder')
      if (order) {
        this.props.setCurrentOrder(JSON.parse(order))
      } else {
        this.props.navigate('/')
      }
    }
  }

  componentDidUpdate() {
    if (document.querySelector('[name="number"]') && !this.initialized) {
      Payment.formatCardNumber(document.querySelector('[name="number"]'))
      Payment.formatCardExpiry(document.querySelector('[name="expiry"]'))
      Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
      this.initialized = true
    }
    if (!this.state.travelers[0]) {
      console.log("this.state.travelers:", this.state.travelers)
      const list = []
      for(let i = 0; i < this.props.order.peopleCount; i++) {
        list.push({ idType: this.idTypes[0] })
      }
      this.setState({ travelers: list })
    }
  }

  render() {
    const { navigate, order, shops, account, placeOrder, currency, locale, goBack, showAlert } = this.props
    if (!order || !shops.length)
      return null

    const { number, name, expiry, cvc, travelers } = this.state
    const shop = _.find(shops, ['id', order.shopId])

    // Setup travelers
    let travelerList = []
    for(let i = 0; i < order.peopleCount; i++) {
      let travelerInfo = <React.Fragment>
        <div className="row">
          <Translate value="name" className="label" />：
          <input name={'traveler'+i+'-name'}
            value={travelers[i] && travelers[i].name}
            onChange={(e) => this.onNameChange(e, i)}
          />
        </div>
        <div className="row">
          <Translate value="birthday" className="label" />：
          <input type="date"
            onChange={(e) => {
              this.updateTraveler(i, { birthday: e.target.value })
            }}
            value={travelers[i] && travelers[i].birthday}
          />
        </div>
        <div className="row">
          <Translate value="idOrPassport" className="label" />：
          <Select
            className="select-front"
            clearable={false}
            name={'fIDTypes'+i}
            value={_.find( this.idTypes, (option) => option === (travelers[i] && travelers[i].idType) ) || this.idTypes[0]}
            onChange={(selected) => this.updateTraveler(i, { idType: selected })}
            options={this.idTypes} />
          <div className='input'>
            <input placeholder={I18n.t('idOrPassport')}
              name={'traveler'+i+'-id'}
              value={travelers[i] && travelers[i].id}
              onChange={(e) => this.onIDChange(e, i)}
            />
            {/* { travelers[i] && travelers[i].isIdValid ? null : <Translate value="invalidNumber" className="danger" /> } */}
          </div>
        </div>
        { i === 0 ?
          <div className="row">
            <Checkbox className="caerulus"
              onChange={(checked) => {
                const traveler = checked ? {
                  name: locale === 'cht' ? ((account.lastName || '') + (account.firstName || ''))
                    : ((account.firstName || '') + (account.lastName || '')),
                  birthday: moment(account.birthday).format('YYYY-MM-DD'),
                  id: account.id
                } : { name: '', birthday: null, id: '' }
                this.updateTraveler(i, traveler)
              }} />
            <Translate value="sameAsCreator" className="label" />
          </div> : null
        }
      </React.Fragment>
      if (order.tags.indexOf('vrtour') < 0) {
        travelerList.push(<Card key={'traveler'+i}>
          <div className="headline">{I18n.t('traveler')+' '+(i+1)}</div>
          { travelerInfo }
        </Card>)
        /* travelerInfo = <React.Fragment>
          <Grid
            container
            direction="row"
          >
            <TextField
              placeholder={I18n.t('firstName')}
              value={travelers[i] && travelers[i].name}
              onChange={(e) => this.onFirstNameChange(e, i)}
              InputLabelProps={{
                shrink: true,
              }}
              style={{ marginRight: 8 }}
              margin="normal"
              variant="outlined"
              required
            />
            <TextField
              placeholder={I18n.t('lastName')}
              value={travelers[i] && travelers[i].name}
              onChange={(e) => this.onLastNameChange(e, i)}
              InputLabelProps={{
                shrink: true,
              }}
              margin="normal"
              variant="outlined"
              required
            />
          </Grid>
          <TextField
            placeholder={I18n.t('phone')}
            value={travelers[i] && travelers[i].phone}
            onChange={(e) => this.onPhoneChange(e, i)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: 8 }}
            type="phone"
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            placeholder={"E-Mail"}
            value={travelers[i] && travelers[i].email}
            onChange={(e) => this.onEmailChange(e, i)}
            InputLabelProps={{
              shrink: true,
            }}
            type="email"
            margin="normal"
            variant="outlined"
            autoComplete="email"
            required
          />
          </React.Fragment> */
      }
    }
    return <div className="order-container">
      <Header title="yourOrder" />
      <Card>
        <Grid
          container
          direction="row"
          className="row title"
        >
          <Translate value="activity" className="label" />：
          <span className="subtitle">{ order.name[locale] }</span>
          <span className="package">{order.packageName !== null && order.packageName[locale]}</span>
          <Chip label={shop && shop.name[locale]}
            onClick={() => navigate('/shop/'+shop.id)}
          />
        </Grid>
        <div className="row">
          <Translate value="time" className="label" />：
          <div className="title">
            { order.startDate + (order.endDate !== order.startDate ? (' - ' + order.endDate) : '') + (order.timeSection && order.timeSection !== -1 ? (' ' + order.timeSection) : '') }
          </div>
        </div>
        <div className="row">
          <Translate value="persons" className="label" />：
          <div className="title">
            {order.peopleCount}
            <Translate value="people" />
          </div>
        </div>
        { order.addons && order.addons.length > 0 && (
          <div className="row">
            <div className="title">
              <Translate value="addons" className="label" />：
              { order.addons.map(addon => (
                  <Grid
                    container
                    direction="row"
                    className="row"
                  >
                    <div>{ addon.name[locale] }</div>
                    <div>{ currency.label.toUpperCase() + ' ' + (Math.ceil(addon.unitPrice * currency.ratio * 100) / 100) + ' X' + (addon.count || 1)}</div>
                  </Grid>
                )
              )}
            </div>
          </div>
        )}
        <div className="row">
          <Translate value="charge" className="label" />：
          <div className="title">
            {currency.label.toUpperCase() + ' ' + Math.ceil(order.peopleCount * order.price * currency.ratio * 100) / 100 }
          </div>
          <Button type="action" text={I18n.t('edit')} onClick={goBack} />
        </div>
      </Card>
      { order.tags.indexOf('vrtour') < 0 && (
        <React.Fragment>
          <Header title="travelerInfo" comment={"travelInsurance"} />
          <form onSubmit={this.onSubmit}>
            { _.map(travelerList, (traveler) => traveler) }
          </form>
        </React.Fragment>
      )}
      <Header title='contactInfo' />
      <Card>
        <Grid container direction="column">
          <TextField
            label={I18n.t('name')}
            placeholder={I18n.t('name')}
            value={this.state.contact.name || account.displayName}
            onChange={(e) => this.onNameChange(e)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: 8 }}
            margin="normal"
            variant="outlined"
            error={!this.state.contact.name && !account.displayName}
            required
          />
          <TextField
            label={I18n.t('phone')}
            placeholder={I18n.t('phone')}
            value={this.state.contact.phone || account.phoneNumber}
            onChange={(e) => this.onPhoneChange(e)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: 8 }}
            margin="normal"
            variant="outlined"
            error={!this.state.contact.phone && !account.phoneNumber}
            required
          />
          <TextField
            label={I18n.t('email')}
            placeholder={I18n.t('email')}
            value={this.state.contact.email || account.email}
            onChange={(e) => this.onEmailChange(e)}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: 8 }}
            margin="normal"
            variant="outlined"
            error={!this.state.contact.email && !account.email}
            required
          />
        </Grid>
        {/* <div className="row">
          <Translate value="name" className="label" />：
          <div className="title">
            {account.displayName}
          </div>
        </div>
        <div className="row">
          <Translate value="phone" className="label" />：
          <div className="title">
            {account.phoneNumber }
          </div>
        </div>
        <div className="row">
          <Translate value="email" className="label" />：
          <div className="title">
            {account.email}
          </div>
        </div> */}
      </Card>
      {/* <Header title="creditCardInfo" comment="creditCardInfoComment" />
      <Card>
        <div className="credit-card-inputs">
          <ReactCreditCard
            number={number}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focused}
            callback={this.handleCallback}
          />
          <form>
            <div>
              <input
                type="tel"
                name="number"
                placeholder={I18n.t('cardNo')}
                onKeyUp={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
              <div className="comment">E.g.: 49..., 51..., 36..., 37...</div>
            </div>
            <div>
              <input
                type="text"
                name="name"
                placeholder={I18n.t('name')}
                onKeyUp={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
            </div>
            <div>
              <input
                type="tel"
                name="expiry"
                placeholder={I18n.t('validThru')}
                onKeyUp={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
              <input
                type="tel"
                name="cvc"
                placeholder="CVC"
                onKeyUp={this.handleInputChange}
                onFocus={this.handleInputFocus}
              />
            </div>
          </form>
        </div>
      </Card> */}
      <div className="footer">
        <Button text={I18n.t('confirmOrderPayArrived')}
          type='action'
          onClick={(event) => {
            let invalid = false, contact = {
              name: this.state.contact.name || account.displayName,
              phone: this.state.contact.phone || account.phoneNumber,
              email: this.state.contact.email || account.email,
            }
            if (order.tags.indexOf('vrtour') < 0) {
              invalid = travelers.length < order.peopleCount || _.find(travelers, (traveler) => {
                // return !(traveler.lastName && traveler.firstName && traveler.phone && traveler.email)
              // } else {
                return !(traveler.name && traveler.birthday && traveler.idType && traveler.id)
              })
            } else {
              invalid = !contact.name || !contact.phone || !contact.email
            }
            if (invalid) {
              showAlert(
                I18n.t(order.tags.indexOf('vrtour') < 0 ? 'plzCompleteTravelerInfo' : 'plzCompleteContactInfo'),
                I18n.t('incompleteData'),
                'warning'
              )
            } else {
              const addonAmount = _.sumBy(order.addons, (addon) => addon.unitPrice * addon.count)
              placeOrder({
                order: { ...order,
                  totalAmount: Math.ceil((order.peopleCount * order.price + addonAmount) * currency.ratio * 100) / 100,
                  date: moment(order.startDate).format('YYYY/MM/DD'),
                  creditCard: { number, name, expiry, cvc },
                  currency: currency.label,
                  currencyRatio: currency.value,
                  travelers,
                  contact,
                },
                isPaid: false,
                status: 'unconfirm',
                account: account
              })
            }
          }}
        />
        {/* <Button text={I18n.t('confirmOrderPayOnline')}
          type='action'
          onClick={(event) => {
            api.payByCredit()
              .then(response => console.log('response: ', response))
            showAlert(
              I18n.t('paymentNotAvailable'),
              I18n.t('unavailable'),
              'warning'
            )
          }}
        /> */}
      </div>
    </div>
  }
}

const mapStateToProps = (state) => ({
  account: state.global.user,
  order: state.order.current,
  shops: state.shop.shops,
  currency: state.global.currency,
  locale: state.i18n.locale,
})
const mapDispatchToProps = (dispatch) => ({
  navigate: (location) => dispatch(push(location)),
  goBack: () => dispatch(goBack()),
  setCurrentOrder: (order) => dispatch(setCurrentOrder(order)),
  placeOrder: (order) => dispatch(placeOrder(order)),
  showAlert: (message, title, type) => dispatch(showAlert(message, title, type)),
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Order)


// WEBPACK FOOTER //
// ./src/containers/Order/index.js